import { render } from "./ConfWebsite.vue?vue&type=template&id=c5c2a3f6"
import script from "./ConfWebsite.vue?vue&type=script&lang=js"
export * from "./ConfWebsite.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__